<template>
    <div class="flex flex-row gap-2 items-center">
        <input :id="id" type="checkbox" :checked="checked" v-model="proxyChecked"
               class=" cursor-pointer rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50">
        <label :for="id" class=" cursor-pointer font-medium text-xs text-gray-700">
            <slot />
        </label>
    </div>
</template>

<script>
export default {
    emits: ['update:checked'],
    props: {
        checked: {
            type: Boolean,
            default: false,
        },
        value: {
            default: null,
        },
    },
    data () {
        return {
            id: null,
        }
    },
    computed: {
        proxyChecked: {
            get() {
                return this.checked;
            },

            set(val) {
                this.$emit("update:checked", val);
            },
        },
    },
    mounted () {
        this.id = this.uuid();
    }
}
</script>
